import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DocumentScannerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"document_scanner"}/>
}
